export class MenuItem {
  name: string
  title: string
  icon: string
  href: string
  to: string
  disabled: boolean
  counter: number

  constructor (data: Partial<MenuItem> = {}) {
    this.name = data.name ?? ''
    this.title = data.title ?? ''
    this.icon = data.icon ?? ''
    this.href = data.href ?? ''
    this.to = data.to ?? ''
    this.disabled = data.disabled ?? false
    this.counter = data.counter ?? 0
  }
}
